import z from "zod";

export type TreeNodeData = {
  id?: string;
  label: string;
  icon?: string;
  type?: "folder" | "file";
  defaultExpanded?: boolean;
  disabled?: boolean;
  children?: TreeNodeData[];
};

export const treeNodeSchema: z.ZodType<TreeNodeData> = z.lazy(() =>
  z.object({
    id: z.string().optional(),
    label: z.string().describe("Visible label for this node."),
    icon: z
      .string()
      .optional()
      .describe(
        "Optional Lucide icon name, overrides the folder/file default.",
      ),
    type: z
      .enum(["folder", "file"])
      .optional()
      .describe(
        "Forces the node's kind. Defaults to folder when it has children, file otherwise.",
      ),
    defaultExpanded: z
      .boolean()
      .optional()
      .describe("Folders default to expanded."),
    disabled: z.boolean().optional(),
    children: z.array(treeNodeSchema).optional(),
  }),
);

export const treeDataSchema = z.object({
  items: z
    .array(treeNodeSchema)
    .default([])
    .describe(
      "Nodes parsed from the light DOM (nested <rwc-tree-item> elements) — not a Twig-authored attribute.",
    ),
});

export type TreeDataProps = z.infer<typeof treeDataSchema>;
